export const cart = {
  name: "cart" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M1.6 3a.9.9 0 0 1 .9-.9H5a.9.9 0 0 1 .88.713L8.275 14.1h10.54l2-7.2H10a.9.9 0 0 1 0-1.8h12a.9.9 0 0 1 .867 1.14l-2.5 9a.9.9 0 0 1-.867.66H8.656l.263 1.236a2.403 2.403 0 0 1 1.806 1.464h5.55a2.4 2.4 0 1 1 0 1.8h-5.55a2.4 2.4 0 1 1-3.567-2.89L4.27 3.9H2.5a.9.9 0 0 1-.9-.9Zm6.9 15.9a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2Zm10 0a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2Z" clip-rule="evenodd"/></svg>`,
  keywords: ["cart"],
  category: "other" as const,
};
